import React from 'react';
import StepPlaceholder from './StepPlaceholder';

const EngagementLetter = () => <StepPlaceholder stepKey="engagement" />;

export default EngagementLetter;
